module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-300-[60]59.42afe1c.woff2";